import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import useWindowSize from "common/functions/useWindowSize.js";

import SurveyModal from "../Rating/SurveyModal.jsx";
import DataUsageCard from "./DashboardDataUsageCard.jsx";
import MyAccountApp from "./DashboardMyaccountApp.jsx";

const Dashboard = (props) => {
  const { width } = useWindowSize();
  //lets stop trying to identity user agent for showing the MyAccountApp component
  //If screen bigger than 1050, lets assume its not mobile
  return (
    <GridContainer justify="center">
      <SurveyModal />
      {width > 1500 ? (
        <GridItem xs={12} md={10} lg={6}>
          <MyAccountApp />
        </GridItem>
      ) : null}
      <GridItem xs={12} md={10} lg={6}>
        <DataUsageCard refresher />
      </GridItem>
    </GridContainer>
  );
};

export default Dashboard;
